import * as React from "react";
import PropTypes from "prop-types";
import { MenuItem, TextField } from "@material-ui/core";
import { cardConditionsByList } from "../../utils/card-condition";

export const CardConditionSelector = ({
    handleConditionChange,
    listName,
    margin = `normal`,
    selectedOption,
    ...props
}) => {
    const validConditions = cardConditionsByList(listName);
    React.useEffect(() => {
        if (!(selectedOption in validConditions)) {
            handleConditionChange({ target: { value: `3` } });
        }
    }, [handleConditionChange, selectedOption, validConditions]);
    return (
        <TextField
            id="select-condition"
            label="Condition"
            margin={margin}
            name="condition"
            onChange={handleConditionChange}
            select
            value={selectedOption}
            variant="outlined"
            {...props}
        >
            {Object.entries(validConditions).map(
                ([conditionId, conditionName]) => (
                    <MenuItem key={conditionId} value={conditionId}>
                        {conditionName}
                    </MenuItem>
                )
            )}
        </TextField>
    );
};

CardConditionSelector.propTypes = {
    handleConditionChange: PropTypes.func.isRequired,
    selectedOption: PropTypes.number,
};
